import { createSelector } from 'reselect';

import { selectCartItems } from './selectCartItems';

export const selectCartBadgeCount = createSelector(
    [selectCartItems],
    (items) => items
        .filter(item => item.quantity > 0)
        .reduce((acc, item) => acc + item.quantity, 0),
);
